import { CHANGELOG } from '../../utils/pageProse';

export type ChangelogEntry = {
  date: string;
  title: string;
  note: string;
};

/** Shipped product changes only. Dates match the git history. No founder byline. */
export const CHANGELOG_ENTRIES: readonly ChangelogEntry[] = [
  {
    date: '2026-08-04',
    title: 'Conversation memory',
    note: `${CHANGELOG.memory} ${CHANGELOG.memoryOff}`,
  },
  {
    date: '2026-08-04',
    title: 'Account deletion',
    note: CHANGELOG.deletion,
  },
  {
    date: '2026-08-01',
    title: 'Documents',
    note: CHANGELOG.documents,
  },
  {
    date: '2026-08-01',
    title: 'Subscriptions',
    note: CHANGELOG.subscriptions,
  },
];
